<iframe
	#photopeaFrame
	*ngIf="url"
	[src]="url"
></iframe>
